import { render, staticRenderFns } from "./shopDecorate.vue?vue&type=template&id=1611c7b3"
import script from "./shopDecorate.vue?vue&type=script&lang=js"
export * from "./shopDecorate.vue?vue&type=script&lang=js"
import style0 from "./shopDecorate.vue?vue&type=style&index=0&id=1611c7b3&prod&lang=less"
import style1 from "./shopDecorate.vue?vue&type=style&index=1&id=1611c7b3&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports